import { Component, Input } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'color-extended-control',
    templateUrl: 'color-extended.control.html',
    standalone: false,
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class ColorExtendedControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    inputType: string = 'color';

    @Input() controlName!: string;
    @Input() showIcon: boolean = true;
    @Input() iconClass: string = 'fas fa-palette';
    @Input() labelText: string = '';
    @Input() placeholderText: string = '';
    @Input() inputClass: string = 'form-control form-control-color';
    @Input() readonly: boolean = false;
    @Input() inputId: string = '';

    @Input() parentFormHelper!: {
        showFieldError(controlName: string): boolean;
        getErrorMessageHtml(controlName: string): string;
    };
}
